import { render, staticRenderFns } from "./ship-apply-detail.vue?vue&type=template&id=3d8573c6&"
import script from "./ship-apply-detail.vue?vue&type=script&lang=js&"
export * from "./ship-apply-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports